import { render, staticRenderFns } from "./PerHead.vue?vue&type=template&id=ba99acfa&scoped=true&"
import script from "./PerHead.vue?vue&type=script&lang=ts&"
export * from "./PerHead.vue?vue&type=script&lang=ts&"
import style0 from "./PerHead.vue?vue&type=style&index=0&id=ba99acfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba99acfa",
  null
  
)

export default component.exports